export enum Page {
  AUDIO,
  LIVEMAP,
  ONRIDEPHOTO,
}
